<template>
  <main class="main-content main-content-bg mt-0">
    <div
      class="page-header min-vh-100"
      style="background-image: url(&quot;/img/bg/login-bg.webp&quot;)"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-7 mt-2">
            <div class="card border-0 mb-0">
              <div class="card-header bg-transparent">
                <h6 class="text-dark text-center mt-3 mb-3">
                  Monitoring Portal
                </h6>
              </div>
              <div class="card-body px-lg-5 pt-0">
                <form role="form" class="text-start">
                  <div class="mb-3">
                    <argon-input
                      id="userId"
                      name="userId"
                      :value="state.userId"
                      placeholder="User Id"
                      aria-label="User Id"
                      is-required
                      :error="v$.userId.$errors.length > 0"
                      @input="(event) => (state.userId = event.target.value)"
                      @blur="v$.userId.$touch"
                    />
                  </div>
                  <div class="mb-3">
                    <argon-input
                      id="password"
                      name="password"
                      :value="state.password"
                      type="password"
                      placeholder="Password"
                      aria-label="Password"
                      is-required
                      :error="v$.password.$errors.length > 0"
                      @input="(event) => (state.password = event.target.value)"
                      @blur="v$.password.$touch"
                    />
                  </div>

                  <div class="text-center">
                    <argon-button
                      full-width
                      color="success"
                      class="my-2 mb-2"
                      native-type="submit"
                      @click.prevent="login()"
                      >LOG IN</argon-button
                    >
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <genodyne-logo class="position-absolute top-0 end-0 mx-5 my-4" />
  <div class="position-absolute bottom-0 start-0 w-100">
    <app-footer />
  </div>
</template>

<script>
import GenodyneLogo from "@/shared/Controls/Icons/GenodyneLogo.vue";
import AppFooter from "@/shared/PageLayout/Footer.vue";
import ArgonInput from "@/shared/Controls/ArgonInput.vue";
import ArgonButton from "@/shared/Controls/ArgonButton.vue";
import { mapMutations } from "vuex";
import { reactive, computed } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import constants from "@/helpers/constants";

export default {
  name: "Login",
  components: {
    GenodyneLogo,
    AppFooter,
    ArgonInput,
    ArgonButton,
  },
  setup() {
    const state = reactive({
      userId: "",
      password: "",
    });

    const rules = computed(() => ({
      userId: { required },
      password: { required },
    }));

    const v$ = useVuelidate(rules, state);

    return { v$, state };
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.toggleDefaultLayout();
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.toggleDefaultLayout();
  },
  methods: {
    ...mapMutations(["toggleDefaultLayout"]),
    async login() {
      const { userId, password } = this.state;
      const result = await this.v$.$validate();
      if (!result) return;

      this.$store
        .dispatch("auth/signIn", {
          userId,
          password,
        })
        .then(() => {
          let signInUser = this.$store.getters["auth/getLoggedInUser"]();
          this.clear();
          // if user is a user_manager, redirect to user accounts page
          if (signInUser && signInUser.role.role_id === constants.ROLES.USER_MANAGER) {
            this.$router.push({ name: "User Accounts"});
          } else {
            this.$router.push({ name: "Home" });
          }
        })
        .catch(() => {
          this.$store.dispatch("auth/setMe", null);
        });
    },
    clear() {
      this.state = {
        userId: "",
        password: "",
      };
    },
  },
};
</script>

<style scoped>
h6 {
  font-family: "Orbitron", "NotoSans-Regular", "Open Sans", sans-serif;
  text-transform: uppercase;
}
</style>
